export default function validaDataExpiracaoCartao(data) {
  const date = data.split('/');

  if (!date || date[0] === '0000') return false;

  const mes = Number(date[0] - 1);
  const ano = Number(2000) + Number(date[1]);
  if (mes > 11 || mes < 0) return false;

  const dataValida = new Date();
  const mesAtual = dataValida.getMonth();
  const anoAtual = dataValida.getFullYear();

  if (anoAtual < ano) return true;
  if (mesAtual <= mes && anoAtual === ano) return true;

  return false;
}
